import { EnvironmentVariableEnum } from './environment-variable.ts';

const appName = EnvironmentVariableEnum.APP_NAME;

export const UrlConst = {
  TOS: 'https://learnwith.ai/terms-of-service',
  PRIVACY: 'https://learnwith.ai/privacy-policy',

  // Once the app is ready for production, we will use this url
  PRODUCTION_APP_HOST: `app.${appName}.learnwith.ai`,
  LOCAL_APP_HOST: 'localhost',
  STAGING_APP_HOST: `pr1.${appName}.rp.devfactory.com`,
};
